"use strict";Object.defineProperty(exports, "__esModule", {value: true}); var _class;

var _chunk64FNDIZXcjs = require('./chunk-64FNDIZX.cjs');


var _chunkHJFO65XKcjs = require('./chunk-HJFO65XK.cjs');

// src/contracts/dex/v2_1/pool/PoolV2_1.ts
var PoolV2_1 = (_class = class extends _chunkHJFO65XKcjs.BasePoolV2_1 {
  static __initStatic() {this.CPI = _chunk64FNDIZXcjs.CPIPoolV2_1}
}, _class.__initStatic(), _class);



exports.PoolV2_1 = PoolV2_1;
//# sourceMappingURL=chunk-5PPYT3PB.cjs.map